import React from "react";
import styled from "styled-components";

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    size?: "sm" | "md" | "lg";
    children?: React.ReactNode;
}

const IconButtonRoot = styled.button<IconButtonProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${({ size }) => {
        if (size === "sm") return "0.25rem";
        if (size === "lg") return "0.75rem";
        return "0.5rem";
    }};
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${({ theme }) => theme.palette.lightGrey};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const IconButton: React.FC<IconButtonProps> = ({ children, ...props }) => {
    return <IconButtonRoot {...props}>{children}</IconButtonRoot>;
};

export default IconButton;


